import { render } from "./user-component.vue?vue&type=template&id=2d5cce62&scoped=true"
import script from "./user-component.vue?vue&type=script&lang=js"
export * from "./user-component.vue?vue&type=script&lang=js"

import "./user-component.vue?vue&type=style&index=0&id=2d5cce62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5cce62"]])

export default __exports__